// Module
var code = "<div class=\"block-2__image-small image\"></div> <div class=\"block-2__image-large image\"></div> ";
// Exports
export default code;